import Hosts from '../../../Hosts';

const object_type = 'Empresa'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/entities`
const api_list_route = companycode => `${Hosts.SIMCore_API}/entities/list/${companycode}/${object_type}`

const base_endpoint = '/empresa'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    view: `${base_endpoint}_view`,
}

const data_interface = {
    id: '',
    info: {
        companycode: '',
        username: '',
        password: '',
        name: '',
        rgpd: false,
        ativo: true,
        vat: '',

        projetos: [{
            id: '',
            codProjeto: '',
            nome: [{
                tipo: {},
                linha: {},

            }],
            nLicenca: '',
            dataInicio: '',    // ver tipo dados
            dataFim: '',       // ver tipo daddos
            assistenciaRemota: false,
            tempoAssistencia: '',  // timer
            assistenciaPermitida: false,
            tickets: [],

        }],

        ticket: [{
            id: '',
            prioridade: '',
            data: '',
            descricao: '',
            solucao: '',
            estado: false,
            cliente: [],
            responsavel: [],
            projetoId: '',
            colaborador: [],
        }],

        identificacao: {
            tipo_identificacao: '',
            numero_identificacao: '',
            validade_identificacao: ''
        },
        observation: '',
        entity_type: ''
    },
    departs: [{
        area: '',
    }],
    addresses: [{
        village: '',
        city: '',
        type: [],
        region: '',
        country: '',
        apartado: '',
        localidade: '',
        contats: [],
        principal: '',
        observation: '',
        postal_code: '',
        street_name: '',
        address_detail: '',
    }],
    contacts: [{
        email: '',
        phone: '',
        principal: 'true',
        extensions: [],
        observation: '',
        mobile_phone: '',
        building_number: '',
        //departamentos: [],
        //codProjeto: [],
        //clientes: [],
        //person_responsables: [], 
        //colaborador:[],
        
        departamentos: [
            { id: 1, nome: 'Comunicação Interna' },
            { id: 2, nome: 'Financeiro' },
            { id: 3, nome: 'Gestão' },
            { id: 4, nome: 'Informática' },
            { id: 5, nome: 'Jurídico' },
            { id: 6, nome: 'Logística' },
            { id: 7, nome: 'Multimédia' },
            { id: 8, nome: 'Pesquisa e Desenvolvimento' },
            { id: 9, nome: 'Produção' },
            { id: 10, nome: 'Recursos Humanos' },
            { id: 11, nome: 'Suporte ao Cliente' },
            { id: 12, nome: 'Tecnologias de Internet' },
        ],
        
        codProjeto: [
            { id: 1, nome: 'SimAlimentação' },
            { id: 2, nome: 'SimPan' },
            { id: 3, nome: 'SimFact' },
            { id: 4, nome: 'SimBeet' },
            { id: 5, nome: 'SimRest' },
            { id: 6, nome: 'Base' },
            { id: 7, nome: 'Extra' },
            { id: 8, nome: 'Light' },
        ],

        clientes: [
            { id: 1, nome: 'Garcia & Filhos', email: 'contact@garciaefilhos.com', mobile_phone: '962348291', descricao: '', codProjeto: [], responsavel: '' },
            { id: 2, nome: 'Padaria PAIFI, Lda', email: 'contact@padariapaifi.com', mobile_phone: '963450382', descricao: '', codProjeto: [], responsavel: '' },
            { id: 3, nome: 'Casa da Isabel', email: 'contact@casadaisabel.com', mobile_phone: '964560473', descricao: '', codProjeto: [], responsavel: '' },
            { id: 4, nome: 'Fábrica Pastelaria S. Silvestre, Lda', email: 'contact@pastelariasilvestre.com', mobile_phone: '965670584', descricao: '', codProjeto: [], responsavel: '' },
            { id: 5, nome: 'Padaria Camponesa', email: 'contact@padariacamponesa.com', mobile_phone: '966780695', descricao: '', codProjeto: [], responsavel: '' },
            { id: 6, nome: 'Mirador & Garcia, Lda', email: 'contact@miradoregarcia.com', mobile_phone: '967890716', descricao: '', codProjeto: [], responsavel: '' },
            { id: 7, nome: 'Padaria Popular de José Armando S. Luís, Lda', email: 'contact@padariapopular.com', mobile_phone: '968900827', descricao: '', codProjeto: [], responsavel: '' },
            { id: 8, nome: 'Panificadora Sul do Cávado, Lda', email: 'contact@suldacavado.com', mobile_phone: '969010938', descricao: '', codProjeto: [], responsavel: '' },
            { id: 9, nome: 'Confeitaria Pôr do Sol, Lda', email: 'contact@pordosolconfeitaria.com', mobile_phone: '960120049', descricao: '', codProjeto: [], responsavel: '' },
            { id: 10, nome: 'Doce Tentação, Lda', email: 'contact@docetentacao.com', mobile_phone: '961230150', descricao: '', codProjeto: [], responsavel: '' },
            { id: 11, nome: 'Panificadora Estrela, Lda', email: 'contact@panificadoraestrela.com', mobile_phone: '962340261', descricao: '', codProjeto: [], responsavel: '' },
            { id: 12, nome: 'Pão Quente & Companhia, Lda', email: 'contact@paoquentecompanhia.com', mobile_phone: '963450372', descricao: '', codProjeto: [], responsavel: '' }
        ],
        
        person_responsables: [
            { id: 1, name: 'Duarte Correia', email: 'duarte.correia332@outlook.com', mobile_phone: '962348291', resp: 'ASSEC', observation: '', departamentos: [1], },
            { id: 2, name: 'Joana Mendes', email: 'joanamendes@email.com', mobile_phone: '963450382', resp: 'ASSEC', observation: '', departamentos: [2, 4] },
            { id: 3, name: 'Mariana Pereira', email: 'marianapereira@email.com', mobile_phone: '964560473', resp: 'ASSEC', observation: '', departamentos: [3, 5] },
            { id: 4, name: 'Vitor Martins', email: 'vitormartins@email.com', mobile_phone: '965670584', resp: 'ASSEC', observation: '', departamentos: [4, 6] },
            { id: 5, name: 'Maria Domingues', email: 'mariadomingues@email.com', mobile_phone: '966780695', resp: 'ASSEC', observation: '', departamentos: [5, 7] },
            { id: 6, name: 'Tânia Matias', email: 'taniamatias@email.com', mobile_phone: '967890716', resp: 'ASSEC', observation: '', departamentos: [6, 8] },
            { id: 7, name: 'Júlio Salcedas', email: 'juliosalcedas@email.com', mobile_phone: '968900827', resp: 'ASSEC', observation: '', departamentos: [7, 9] },
            { id: 8, name: 'Ricardo Almeida', email: 'ricardoalmeida@email.com', mobile_phone: '969010938', resp: 'ASSEC', observation: '', departamentos: [8, 10] },
            { id: 9, name: 'Tiago Fernandes', email: 'tiagofernandes@email.com', mobile_phone: '960120049', resp: 'ASSEC', observation: '', departamentos: [9, 11] },
            { id: 10, name: 'Catarina Nunes', email: 'catarinanunes@email.com', mobile_phone: '961230150', resp: 'ASSEC', observation: '', departamentos: [10, 12] },
            { id: 11, name: 'Bruno Rodrigues', email: 'brunorodrigues@email.com', mobile_phone: '962340261', resp: 'ASSEC', observation: '', departamentos: [1, 11] },
            { id: 12, name: 'Sofia Oliveira', email: 'sofiaoliveira@email.com', mobile_phone: '963450372', resp: 'ASSEC', observation: '', departamentos: [1, 12] },
            { id: 13, name: 'David Fernandes', email: 'smokasmetin2@gmail.com', mobile_phone: '969348291', resp: 'ASSEC', observation: '', departamentos: [1, 2, 3, 6] },
        ],
        
        colaborador: [
            { id: 1, nome: 'David Fernandes', email: 'davidfernandes@outlook.com', mobile_phone: '962348291', descricao: '', tickets: [] },
            { id: 2, nome: 'Duarte Correia', email: 'duarte.correia332@outlook.com', mobile_phone: '963450382', descricao: '', tickets: [] },
        ],

    }],
    profile: { name: "Empresa" },
    notifications: []
}

export {
    object_type,
    endpoints,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route
}
